var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar64748B(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.55 3.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.45 1.65C2.008 1.65 1.65 2.008 1.65 2.45L1.65 16.45C1.65 16.892 2.008 17.25 2.45 17.25L16.45 17.25C16.892 17.25 17.25 16.892 17.25 16.45L17.25 2.45C17.25 2.008 16.892 1.65 16.45 1.65L2.45 1.65ZM0 2.45C0 0.683 0.683 0 2.45 0L16.45 0C18.217 0 18.9 0.683 18.9 2.45L18.9 16.45C18.9 18.217 18.217 18.9 16.45 18.9L2.45 18.9C0.683 18.9 0 18.217 0 16.45L0 2.45Z",
    fill: "#64748b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.125 0C1.746 0 2.25 0.441 2.25 0.984L2.25 4.266C2.25 4.809 1.746 5.25 1.125 5.25C0.504 5.25 0 4.809 0 4.266L0 0.984C0 0.441 0.504 0 1.125 0Z",
    fill: "#64748b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.75 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.125 0C1.746 0 2.25 0.441 2.25 0.984L2.25 4.266C2.25 4.809 1.746 5.25 1.125 5.25C0.504 5.25 0 4.809 0 4.266L0 0.984C0 0.441 0.504 0 1.125 0Z",
    fill: "#64748b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75C0 0.336 0.474 0 1.059 0L16.941 0C17.526 0 18 0.336 18 0.75C18 1.164 17.526 1.5 16.941 1.5L1.059 1.5C0.474 1.5 0 1.164 0 0.75Z",
    fill: "#64748b",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar64748B);
export default __webpack_public_path__ + "static/media/calendar-64748b.823a3e3a11274f9b786bc82bfa7195c8.svg";
export { ForwardRef as ReactComponent };